export default __webpack_public_path__ + "static/media/green_menu_mob.ad308c7c.svg";